import { outdent as outdent_1 } from './outdent.locstring.json';
import loc from 'owa-localize';
import RibbonButton from './RibbonButton';

import { Indentation } from 'roosterjs-editor-types';
import { setIndentation } from 'roosterjs-editor-api';

const outdent: RibbonButton = {
    key: 'outdent',
    title: () => loc(outdent_1),
    imageSrc: require('../svg/outdent.svg'),
    imageRtlSrc: require('../svg/outdent-rtl.svg'),
    onExecute: (plugin, logUsage) => {
        setIndentation(plugin.getEditor(), Indentation.Decrease);
        logUsage('setIndentation', Indentation.Decrease);
    },
};

export default outdent;
